import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { CheckCircle } from 'lucide-react';
export function DonationTiers() {
  const [isMonthly, setIsMonthly] = useState(false);
  const tiers = [{
    amount: 35,
    title: 'Starter',
    description: 'Provides basic medical supplies for a day of clinic operations',
    impact: 'Helps treat approximately 10 patients'
  }, {
    amount: 100,
    title: 'Supporter',
    description: 'Supplies essential medications and wound care items for a week',
    impact: 'Helps treat approximately 30 patients',
    highlighted: true
  }, {
    amount: 250,
    title: 'Sustainer',
    description: 'Delivers a comprehensive supply of medical essentials',
    impact: 'Helps treat approximately 75 patients'
  }, {
    amount: 1000,
    title: 'Champion',
    description: 'Provides specialized equipment and critical medications',
    impact: 'Helps treat approximately 300 patients'
  }];
  return <Section background="white" data-id="element-53">
      <div className="text-center mb-12" data-id="element-54">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-55">
          Make a Difference Today
        </h2>
        <p className="text-lg font-inter text-neutral-charcoal max-w-3xl mx-auto" data-id="element-56">
          Your donation directly supports the delivery of critical medical
          supplies to underserved communities.
        </p>
        <div className="flex justify-center mt-6" data-id="element-57">
          <div className="inline-flex bg-neutral-offwhite p-1 rounded-lg" data-id="element-58">
            <button className={`px-4 py-2 rounded-md font-inter ${!isMonthly ? 'bg-white shadow-sm' : ''}`} onClick={() => setIsMonthly(false)} data-id="element-59">
              One-time
            </button>
            <button className={`px-4 py-2 rounded-md font-inter ${isMonthly ? 'bg-white shadow-sm' : ''}`} onClick={() => setIsMonthly(true)} data-id="element-60">
              Monthly
            </button>
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-61">
        {tiers.map((tier, index) => <div key={index} className={`rounded-xl p-6 ${tier.highlighted ? 'border-2 border-primary-gold shadow-lg' : 'border border-neutral-offwhite'}`} data-id="element-62">
            <div className="font-playfair font-bold text-3xl text-primary-deep-blue mb-2" data-id="element-63">
              ${tier.amount}
              {isMonthly ? <span className="text-lg" data-id="element-64">/mo</span> : ''}
            </div>
            <h3 className="font-playfair font-bold text-xl text-primary-deep-blue mb-4" data-id="element-65">
              {tier.title}
            </h3>
            <p className="font-inter text-neutral-charcoal mb-4" data-id="element-66">
              {tier.description}
            </p>
            <div className="flex items-center mb-6" data-id="element-67">
              <CheckCircle size={18} className="text-primary-royal-blue mr-2" data-id="element-68" />
              <span className="font-inter text-neutral-charcoal" data-id="element-69">
                {tier.impact}
              </span>
            </div>
            <Button href="https://www.paypal.com/donate/?hosted_button_id=555JFTK9EZ7LU" variant={tier.highlighted ? 'primary' : 'secondary'} className="w-full" data-id="element-70">
              Donate {isMonthly ? 'Monthly' : 'Now'}
            </Button>
          </div>)}
      </div>
      <div className="mt-8 text-center" data-id="element-71">
        <p className="font-inter text-neutral-charcoal" data-id="element-72">
          Want to donate a different amount or make a donation in someone's
          honor?
        </p>
        <Button href="https://www.paypal.com/donate/?hosted_button_id=555JFTK9EZ7LU" variant="tertiary" className="mt-2" data-id="element-73">
          View all donation options
        </Button>
      </div>
    </Section>;
}